import { MenuItem, Select, Typography } from "@mui/material";
import type { SelectProps } from "@mui/material";
import { AdmAuth } from "@/constants/code";
import { forwardRef } from "react";

export type AuthSelectProps = Omit<
  SelectProps<AdmAuth>,
  "children" | "multiple"
>;

/**
 * 관리자 권한 선택 컴포넌트
 *
 * @param {AuthSelectProps} props
 * @returns {JSX.Element}
 *
 * @author bart <bart@ymjlab.com>
 * @version 1.0.0
 * @since 2024-12-24
 */
export const AuthSelect = forwardRef<HTMLInputElement, AuthSelectProps>(
  (props: AuthSelectProps, ref) => {
    return (
      <Select
        {...props}
        ref={ref}
        displayEmpty
        renderValue={(selected) => {
          if (!selected) {
            return (
              <Typography color="textDisabled" fontWeight={"normal"}>
                권한을 선택해주세요.
              </Typography>
            );
          }

          const authTypes = {
            [AdmAuth.Super]: "슈퍼 관리자",
            [AdmAuth.Admin]: "일반 관리자",
            [AdmAuth.Manager]: "도장 매니저",
            [AdmAuth.Coach]: "코치",
          };

          return authTypes[selected];
        }}
      >
        <MenuItem value={AdmAuth.Super} sx={{ fontSize: "0.875rem" }}>
          슈퍼 관리자
        </MenuItem>
        <MenuItem value={AdmAuth.Admin} sx={{ fontSize: "0.875rem" }}>
          일반 관리자
        </MenuItem>
        <MenuItem value={AdmAuth.Manager} sx={{ fontSize: "0.875rem" }}>
          도장 매니저
        </MenuItem>
        <MenuItem value={AdmAuth.Coach} sx={{ fontSize: "0.875rem" }}>
          코치
        </MenuItem>
      </Select>
    );
  }
);
